/**
 * 派单占位组件
 * 用于暂不支持派单的订单类型（中医、牙医、到家）
 */
import React from 'react'
import { Empty } from 'antd'

const DispatcherPlaceholder = () => (
  <div className="dispatcher-placeholder">
    <Empty description="该订单类型暂不支持派单" />
  </div>
)

export default DispatcherPlaceholder
